import {
  EStockReconciliationUoM,
  EStockReconciliationVarianceType,
} from 'entities/StockReconciliation/StockReconciliation.models';

export const stockReconciliationUomOptions = [
  { value: EStockReconciliationUoM.Packs, label: 'Packs' },
  { value: EStockReconciliationUoM.Pcs, label: 'Pcs' },
];

export const stockReconciliationVarianceOptions = [
  { value: EStockReconciliationVarianceType.All, label: 'All' },
  { value: EStockReconciliationVarianceType.Positive, label: 'Positive' },
  { value: EStockReconciliationVarianceType.Negative, label: 'Negative' },
];

export const STOCK_RECONCILIATION_SHIFTS_LIMIT = 10;
export const STOCK_RECONCILIATION_DATA_UNAVAILABLE_TOOLTIP = 'Data unavailable';
export const STOCK_RECONCILIATION_TRANSFERS_TOOLTIP = 'Transfers not tracked';
export const STOCK_RECONCILIATION_DASH = '—';
